import React, { FC } from 'react';
import { ContentCardItemWithId, ContentCardsRow } from '@modernhealth/vital-components';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { ContentCardProps } from './ContentCard';
import { mapContentLinkToContentCardProps } from '../helpers/contentLinkNodeToContentCard';

export const HorizontalContentCard: FC<ContentCardProps> = ({ links }) => {
    const { showCirclesInMemberWeb } = useFlags();

    if (!links) {
        return null;
    }

    const mappedLinks = links
        .map(link => mapContentLinkToContentCardProps(link, showCirclesInMemberWeb))
        .filter((link): link is ContentCardItemWithId => link !== null);

    return <ContentCardsRow items={mappedLinks} cardTestID="ContentCardsRow-" />;
};
